let env: string;
let edgeServiceUrl: string;
let segmentWriteKey: string;
let googleApiKey: string;
let sdkUrl: string;
let dealerPortalUrl: string;
let associatePortalUrl: string;
let launchDarklyApiKey: string;
let socurePublicKey: string;
let nonTaxInclusiveVcCompanyDealerIds: number[];
let defaultLeaseDurationOptions: {
  preferredTerms: number[];
};

interface Config {
  env: string;
  edgeServiceUrl: string;
  segmentWriteKey: string;
  googleApiKey: string;
  sdkUrl: string;
  dealerPortalUrl: string;
  associatePortalUrl: string;
  launchDarklyApiKey: string;
  // Public Socure Digital Intelligence SDK key from the Socure admin portal. Sandbox key by
  // default; prod key overridden in the prod branch. See OR-2838.
  socurePublicKey: string;
  // Virtual Card finance amounts are tax-inclusive by default; these VC companies are the
  // exception (NOT tax-inclusive, e.g. Farmers). Keyed by company dealer id (one company covers
  // all its stores). Per-environment since company dealer ids differ. See OR-2639.
  nonTaxInclusiveVcCompanyDealerIds: number[];
  defaultLeaseDurationOptions: {
    preferredTerms: number[];
  };
}

const getEnvConfig = (hostname = window?.location?.hostname, queryParams = new URLSearchParams(window.location.search), envVars = import.meta.env) => {
  // Defaults to no exemptions (all VC treated as tax-inclusive); override per-env in the branches below.
  nonTaxInclusiveVcCompanyDealerIds = [];
  // Defaults to the Socure sandbox SDK key; the prod branch overrides with the production key.
  socurePublicKey = 'f7e58dfc-1bc3-468e-823f-53bbf43569db';
  if (hostname === 'epply.koalafi.com') {
    env = 'prod';
    nonTaxInclusiveVcCompanyDealerIds = [3347];
    socurePublicKey = 'bd542e36-043f-45d5-adee-7751ee7e29cd';
    edgeServiceUrl = 'https://application-edge-service.koalafi.com/query';
    segmentWriteKey = 'l1PTDCipwvubNqfFPO276xZ8yZt0cJj9';
    googleApiKey = 'AIzaSyCn262hdrH9l8JNqEi5pB-RJgNaZqkw6ek';
    sdkUrl = 'https://ecomm-sdk.koalafi.com';
    dealerPortalUrl = 'https://dealer.koalafi.com';
    associatePortalUrl = 'https://associate.koalafi.com';
    launchDarklyApiKey = '686edb489dd903092ec9bebf';
  } else if (/dev/.test(hostname)) {
    env = 'dev';
    nonTaxInclusiveVcCompanyDealerIds = [614];
    edgeServiceUrl = 'https://application-edge-service.dev.koalafi.com/query';
    segmentWriteKey = 'nAmtK8FJpulyIdntaj29f7XED49vFp8c';
    googleApiKey = 'AIzaSyCjLo1ArM2-gTheuEDJ32FfFkQk_GDvzHg';
    sdkUrl = 'https://ecomm-sdk.dev.koalafi.com';
    dealerPortalUrl = 'https://dealer.dev.koalafi.com';
    associatePortalUrl = 'https://associate.dev.koalafi.com';
    launchDarklyApiKey = '68acbfebb3512d0a61ff4504';
  } else if (/epply1.qa/.test(hostname)) {
    env = 'qa1';
    edgeServiceUrl = 'https://application-edge-service1.qa.koalafi.com/query';
    segmentWriteKey = 'nAmtK8FJpulyIdntaj29f7XED49vFp8c';
    googleApiKey = 'AIzaSyCjLo1ArM2-gTheuEDJ32FfFkQk_GDvzHg';
    sdkUrl = 'https://ecomm-sdk1.qa.koalafi.com';
    dealerPortalUrl = 'https://dealer.qa.koalafi.com';
    associatePortalUrl = 'https://associate.qa.koalafi.com';
    launchDarklyApiKey = '68acbfebb3512d0a61ff4504';
  } else if (/epply2.qa/.test(hostname)) {
    env = 'qa2';
    edgeServiceUrl = 'https://application-edge-service2.qa.koalafi.com/query';
    segmentWriteKey = 'nAmtK8FJpulyIdntaj29f7XED49vFp8c';
    googleApiKey = 'AIzaSyCjLo1ArM2-gTheuEDJ32FfFkQk_GDvzHg';
    sdkUrl = 'https://ecomm-sdk2.qa.koalafi.com';
    dealerPortalUrl = 'https://dealer2.qa.koalafi.com';
    associatePortalUrl = 'https://associate2.qa.koalafi.com';
    launchDarklyApiKey = '68acbfebb3512d0a61ff4504';
  } else if (/epply3.qa/.test(hostname)) {
    env = 'qa3';
    edgeServiceUrl = 'https://application-edge-service3.qa.koalafi.com/query';
    segmentWriteKey = 'nAmtK8FJpulyIdntaj29f7XED49vFp8c';
    googleApiKey = 'AIzaSyCjLo1ArM2-gTheuEDJ32FfFkQk_GDvzHg';
    sdkUrl = 'https://ecomm-sdk3.qa.koalafi.com';
    dealerPortalUrl = 'https://dealer3.qa.koalafi.com';
    associatePortalUrl = 'https://associate3.qa.koalafi.com';
    launchDarklyApiKey = '68acbfebb3512d0a61ff4504';
  } else if (/stage/.test(hostname)) {
    env = 'stage';
    edgeServiceUrl = 'https://application-edge-service.stage.koalafi.com/query';
    segmentWriteKey = 'b6K1gsPxJS9ZghRdtc1H6CTT6e1FGPAJ';
    googleApiKey = 'AIzaSyCjLo1ArM2-gTheuEDJ32FfFkQk_GDvzHg';
    sdkUrl = 'https://ecomm-sdk.sandbox.koalafi.com';
    dealerPortalUrl = 'https://dealer.stage.koalafi.com';
    associatePortalUrl = 'https://associate.stage.koalafi.com';
    launchDarklyApiKey = '68ddbbee99cfdc09b910e4c1';
  } else if (/sandbox/.test(hostname) && !queryParams.has('stage')) {
    env = 'sandbox';
    edgeServiceUrl = 'https://application-edge-service.sandbox.koalafi.com/query';
    segmentWriteKey = 'b6K1gsPxJS9ZghRdtc1H6CTT6e1FGPAJ';
    googleApiKey = 'AIzaSyCjLo1ArM2-gTheuEDJ32FfFkQk_GDvzHg';
    sdkUrl = 'https://ecomm-sdk.sandbox.koalafi.com';
    dealerPortalUrl = 'https://dealer.stage.koalafi.com';
    associatePortalUrl = 'https://associate.stage.koalafi.com';
    launchDarklyApiKey = '68ddbbee99cfdc09b910e4c1';
  } else if (/sandbox/.test(hostname) && queryParams.has('stage')) {
    env = 'sandbox';
    edgeServiceUrl = 'https://application-edge-service.stage.koalafi.com/query';
    segmentWriteKey = 'b6K1gsPxJS9ZghRdtc1H6CTT6e1FGPAJ';
    googleApiKey = 'AIzaSyCjLo1ArM2-gTheuEDJ32FfFkQk_GDvzHg';
    sdkUrl = 'https://ecomm-sdk.sandbox.koalafi.com';
    dealerPortalUrl = 'https://dealer.stage.koalafi.com';
    associatePortalUrl = 'https://associate.stage.koalafi.com';
    launchDarklyApiKey = '68ddbbee99cfdc09b910e4c1';
  } else if (envVars.VITE_GRAPH_QL_ENDPOINT) {
    // e2e testing - adding dev segment tracking for now. Can remove later
    env = 'e2e';
    edgeServiceUrl = envVars.VITE_GRAPH_QL_ENDPOINT;
    segmentWriteKey = 'nAmtK8FJpulyIdntaj29f7XED49vFp8c';
    googleApiKey = 'AIzaSyCjLo1ArM2-gTheuEDJ32FfFkQk_GDvzHg';
    sdkUrl = 'https://ecomm-sdk1.qa.koalafi.com';
    dealerPortalUrl = 'https://dealer.qa.koalafi.com';
    associatePortalUrl = 'https://associate.qa.koalafi.com';
    launchDarklyApiKey = '68acbfebb3512d0a61ff4504';
  } else {
    // It looks like, based on our current config in package.json, we never run with the environment "local", only "development". So this configuration is probably never reached.
    env = 'local';
    edgeServiceUrl = 'http://localhost:8080/query';
    segmentWriteKey = 'nAmtK8FJpulyIdntaj29f7XED49vFp8c';
    googleApiKey = 'AIzaSyCjLo1ArM2-gTheuEDJ32FfFkQk_GDvzHg';
    sdkUrl = 'http://localhost:3001';
    dealerPortalUrl = 'https://dealer.dev.koalafi.com';
    associatePortalUrl = 'https://associate.dev.koalafi.com';
    // Koalafi Project "Local" ClientID, but as noted above, this isn't currently used.
    launchDarklyApiKey = '68acc226e49a2f0abfd288b0';
  }

  // Common to all environments
  defaultLeaseDurationOptions = {
    preferredTerms: [18, 24],
  };

  return {
    env,
    edgeServiceUrl,
    segmentWriteKey,
    googleApiKey,
    sdkUrl,
    dealerPortalUrl,
    associatePortalUrl,
    launchDarklyApiKey,
    socurePublicKey,
    nonTaxInclusiveVcCompanyDealerIds,
    defaultLeaseDurationOptions,
  };
};

let AppConfig: Config = getEnvConfig();

export { AppConfig, getEnvConfig };
